export function getStaffAvatarUrl(login, size) {
  var path = "api/v1/user/".concat(login, "/avatar");

  if (size) {
    path += "/".concat(size);
  }

  path += '.jpg';
  var url = new URL(path, 'https://center.yandex-team.ru');
  return url.toString();
}
// #sourceMappingURL=getStaffAvatarUrl.js.map